var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLismenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3227",
    "data-name": "Group 3227",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.294,
    height: 14.559,
    viewBox: "0 0 19.294 14.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1045",
    "data-name": "Rectangle 1045",
    width: 19.294,
    height: 14.559,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3226",
    "data-name": "Group 3226",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2796",
    "data-name": "Path 2796",
    d: "M84.552,99.6a1.086,1.086,0,0,1-1.145.73q-6.316-.011-12.631,0a.99.99,0,1,1-.113-1.977c.069,0,.138,0,.207,0q6.269,0,12.537,0a1.086,1.086,0,0,1,1.145.73Z",
    transform: "translate(-65.258 -92.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2797",
    "data-name": "Path 2797",
    d: "M84.5,5.25A1.026,1.026,0,0,1,83.414,6q-6.324,0-12.648,0a1,1,0,0,1-1.092-.831.98.98,0,0,1,.874-1.14c.075,0,.151,0,.226,0q6.314,0,12.629,0a1.039,1.039,0,0,1,1.1.733Z",
    transform: "translate(-65.204 -3.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2798",
    "data-name": "Path 2798",
    d: "M84.527,194.022a1.039,1.039,0,0,1-1.1.733q-6.361-.012-12.723,0a.963.963,0,0,1-1-.789.975.975,0,0,1,.77-1.151,2.2,2.2,0,0,1,.374-.032q6.277,0,12.553,0a1.036,1.036,0,0,1,1.122.756Z",
    transform: "translate(-65.232 -180.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2799",
    "data-name": "Path 2799",
    d: "M0,94.524A1.315,1.315,0,0,1,1.291,93.2a1.322,1.322,0,1,1,0,2.644A1.316,1.316,0,0,1,0,94.524",
    transform: "translate(0 -87.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2800",
    "data-name": "Path 2800",
    d: "M0,1.319A1.294,1.294,0,0,1,1.306,0,1.311,1.311,0,1,1,1.3,2.622,1.284,1.284,0,0,1,0,1.319",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2801",
    "data-name": "Path 2801",
    d: "M0,188.04a1.284,1.284,0,0,1,1.316-1.3,1.311,1.311,0,1,1-.011,2.623A1.294,1.294,0,0,1,0,188.04",
    transform: "translate(0 -174.801)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLismenu);
export default __webpack_public_path__ + "static/media/icon_lismenu.1b8900e09828a0b3c251df29c03b698d.svg";
export { ForwardRef as ReactComponent };